import { useCreateStandardOrderBumbalDate } from "app/hooks/checkout/useCreateStandardOrderBumbalDate";
import { toast } from "react-toastify";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";

type StandardOrderAppointmentFooterProps = {
  date: Date | null;
  standardOrderId: string;
  bumbalType: string;
  bumbalAlreadyPlanned: boolean;
};
export const StandardOrderAppointmentFooter = ({
  date,
  standardOrderId,
  bumbalType,
  bumbalAlreadyPlanned,
}: StandardOrderAppointmentFooterProps) => {
  const { mutateAsync, isLoading } = useCreateStandardOrderBumbalDate();
  const proceedWithAppointment = async () => {
    if (date) {
      mutateAsync(
        {
          orderId: standardOrderId,
          type: bumbalType,
          selectedDate: date,
        },
        {
          onSuccess: () => {
            window.location.href = `/afspraak-bedankt?type=${bumbalType}&standardOrderId=${standardOrderId}`;
          },
          onError: (err) => {
            toast.error(
              "Er is iets fout gegaan bij het plannen van de afspraak.",
            );
          },
        },
      );
    }
  };

  const disabledState = !date || isLoading || bumbalAlreadyPlanned;
  const loadingState = isLoading;
  return (
    <footer
      className={concatClassnames(
        "gg-px-4 sm:gg-px-14 md:gg-px-16 lg:gg-px-14 xl:gg-px-14 2xl:gg-px-32",
        "gg-grid gg-gap-y-5 gg-bg-dark-blue gg-py-11 gg-text-white",
        "gg-items-center sm:gg-flex sm:gg-justify-end sm:gg-gap-x-8",
      )}
    >
      <Button
        type={ButtonTypes.YELLOW}
        arrow={ButtonArrowTypes.RIGHT}
        onClick={proceedWithAppointment}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-px-5 gg-py-3 lg:gg-w-fit lg:gg-px-10 xl:gg-py-3.5"
        disabled={disabledState}
        loading={loadingState}
      >
        Verder
      </Button>
    </footer>
  );
};
